import { render, staticRenderFns } from "./sale-area-name.vue?vue&type=template&id=69bcd540"
import script from "./sale-area-name.vue?vue&type=script&lang=ts"
export * from "./sale-area-name.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69bcd540')) {
      api.createRecord('69bcd540', component.options)
    } else {
      api.reload('69bcd540', component.options)
    }
    module.hot.accept("./sale-area-name.vue?vue&type=template&id=69bcd540", function () {
      api.rerender('69bcd540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sale-area-name.vue"
export default component.exports